if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        /* TPL 2026-05-10: kick play() on the modal's native autoplay video.
           ModalDialog.show() called pauseAllMedia() during super.show(), which
           pauses our autoplay element before the user even sees it. */
        if (activeMedia.classList && activeMedia.classList.contains('tpl-pdp-video')) {
          const v = activeMedia.querySelector('video');
          if (v) {
            v.muted = true;
            v.playsInline = true;
            const p = v.play();
            if (p && typeof p.catch === 'function') p.catch(() => {});
          }
        }
      }
    }
  );
}
